import styled from "@emotion/styled";
import { MDSSeparator } from "@/mds";

export const StyledAccountMenuWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledSpinnerWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const StyledCalendarList = styled.div<{ isDisabled?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing[2]};
  padding-top: ${({ theme }) => theme.spacing[2]};
  ${({ isDisabled }) =>
    isDisabled &&
    `
    opacity: 0.5;
    pointer-events: none;
  `}
`;

export const StyledCalendarSeparator = styled(MDSSeparator)`
  margin: ${({ theme }) => theme.spacing[2]} 0;
`;

export const StyledDisconnectedText = styled.span`
  color: ${({ theme }) => theme.colors.text.danger};
  font-size: ${({ theme }) => theme.fontSizes["text-sm"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
`;

export const StyledReconnectButtonWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyledRightAddonActionsWrapper = styled.span<{ slot?: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing[2]};
`;
